import { cldConfig } from '../config/cloudinary';

const CLOUD = cldConfig.cloudName || 'dkyoxq3cc';

/**
 * Build browser-friendly Cloudinary URLs for PDFs (inline view, preview page, download).
 * PDFs should be uploaded with resource_type "image" for pg_1 previews to work.
 */
export function enrichCloudinaryFileMeta(meta, { isPdf = false } = {}) {
  if (!meta?.url && !meta?.publicId) return meta;

  const publicId = meta.publicId;
  const resourceType = meta.resourceType || (isPdf ? 'image' : 'raw');
  const imageBase = `https://res.cloudinary.com/${CLOUD}/image/upload`;

  if (isPdf && publicId) {
    const id = publicId.includes('.') ? publicId : `${publicId}.pdf`;
    return {
      ...meta,
      resourceType: 'image',
      format: meta.format || 'pdf',
      url: meta.url || `${imageBase}/${id}`,
      viewUrl: meta.url || `${imageBase}/${id}`,
      previewUrl: `${imageBase}/pg_1,w_900/${id}`,
      downloadUrl: `${imageBase}/fl_attachment/${id}`,
    };
  }

  if (publicId && resourceType === 'image') {
    return {
      ...meta,
      viewUrl: meta.url,
      previewUrl: meta.url,
      downloadUrl: meta.url?.replace('/upload/', '/upload/fl_attachment/') || meta.url,
    };
  }

  return {
    ...meta,
    viewUrl: meta.url,
    downloadUrl: meta.url,
    previewUrl: meta.url,
  };
}

/** Resolve display URLs for admin (handles legacy raw uploads). */
export function getFileDisplayUrls(fileMeta) {
  if (!fileMeta) return null;
  const isPdf =
    fileMeta.format === 'pdf' ||
    fileMeta.originalName?.toLowerCase().endsWith('.pdf') ||
    fileMeta.publicId?.toLowerCase().endsWith('.pdf') ||
    fileMeta.url?.toLowerCase().includes('.pdf');

  const enriched = enrichCloudinaryFileMeta(fileMeta, { isPdf });
  return {
    viewUrl: enriched.viewUrl || enriched.url,
    previewUrl: enriched.previewUrl || enriched.viewUrl || enriched.url,
    downloadUrl: enriched.downloadUrl || enriched.url,
    originalName: enriched.originalName || 'Document',
  };
}
